module.exports = __webpack_public_path__ + "img/edit.0af6a188.svg";